import _sfc_main from "./devtools.vue.js";
import _sfc_main$1 from "./devtoolsPanel.vue.js";
const VueQueryDevtools = process.env.NODE_ENV !== "development" ? function() {
  return null;
} : _sfc_main;
const VueQueryDevtoolsPanel = process.env.NODE_ENV !== "development" ? function() {
  return null;
} : _sfc_main$1;
export {
  VueQueryDevtools,
  VueQueryDevtoolsPanel
};
//# sourceMappingURL=index.js.map
